import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
    
    name : 'authslice',
    
    initialState : {
        authToken : 'authToken',
        userEmail : null,
        userRole : null,
    },

    reducers : {
        setCredentials : (state, action) => {
            state.userEmail = action.payload;
            state.authToken = action.payload;
            state.userRole = action.payload;
        },

        logout : (state, action) => {
            state.userEmail = null;
            state.authToken = null;
            state.userRole = null;
        }
    }

});

export const {setCredentials, logout} = authSlice.actions;
export const selectAuthToken = (state) => state.auth.authToken;
export const selectUserEmail = (state) => state.auth.userEmail;
export const selectUserRole = (state) => state.auth.userRole;
export default authSlice.reducer;